export enum snackbarActionNames {
  ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR',
  CLOSE_SNACKBAR = 'CLOSE_SNACKBAR',
  REMOVE_SNACKBAR = 'REMOVE_SNACKBAR',
}

export interface SnackbarOptions {
  persist?: boolean;
  key?: string;
  variant?: string;
  dismissed?: boolean;
  action?: Function;
  downloadAction?: Function;
  downloadMessage?: string;
  resumeHideDuration?: number;
  content?: React.ReactNode | Function;
}

export interface Notification {
  message?: string;
  options?: SnackbarOptions;
}

export interface SnackbarState {
  notifications: Array<any>;
}

interface SetEnqueueSnackbar {
  type: typeof snackbarActionNames.ENQUEUE_SNACKBAR;
  notification: any;
}

interface SetCloseSnackbar {
  type: typeof snackbarActionNames.CLOSE_SNACKBAR;
  notification: any;
}

interface SetRemoveSnackbar {
  type: typeof snackbarActionNames.REMOVE_SNACKBAR;
  notification: any;
}

export type SnackbarActionTypes = SetEnqueueSnackbar | SetCloseSnackbar | SetRemoveSnackbar;
